export const FIRST_NAME_FIELD_NAME = 'First name / Pangalan';
export const LAST_NAME_FIELD_NAME = 'Last name / Apelydio';
export const MIDDLE_NAME_FIELD_NAME = 'Middle name (if any)';
export const CITIZENSHIP_FIELD_NAME = 'Citizenship';
export const EMAIL_FIELD_NAME = 'Email';
export const NICKNAME_FIELD_NAME = 'Nickname (optional)';
